import image08 from '@/assets/states/baden-wuerttemberg.png';
import image09 from '@/assets/states/bayern.png';
import image11 from '@/assets/states/berlin.png';
import image12 from '@/assets/states/brandenburg.png';
import image04 from '@/assets/states/bremen.png';
import image02 from '@/assets/states/hamburg.png';
import image06 from '@/assets/states/hessen.png';
import image13 from '@/assets/states/mecklenburg-vorpommern.png';
import image03 from '@/assets/states/niedersachsen.png';
import image05 from '@/assets/states/nordrhein-westfalen.png';
import image07 from '@/assets/states/rheinland-pfalz.png';
import image10 from '@/assets/states/saarland.png';
import image14 from '@/assets/states/sachsen.png';
import image15 from '@/assets/states/sachsen-anhalt.png';
import image01 from '@/assets/states/schleswig-holstein.png';
import image16 from '@/assets/states/thueringen.png';

export const icons = {
    DEBW: image08,
    DEBY: image09,
    DEBE: image11,
    DEBB: image12,
    DEHB: image04,
    DEHH: image02,
    DEHE: image06,
    DEMV: image13,
    DENI: image03,
    DENW: image05,
    DERP: image07,
    DESL: image10,
    DESN: image14,
    DEST: image15,
    DESH: image01,
    DETH: image16
};

const customers = [
    {
        key: 'DEBW',
        name: 'Ministerium für Ernährung, Ländlichen Raum und Verbraucherschutz Baden-Württemberg (MLR)',
        destatis: '08'
    },
    {
        key: 'DEBY',
        name: 'Bayerisches Landesamt für Gesundheit und Lebensmittelsicherheit (LGL)',
        destatis: '09'
    },
    {
        key: 'DEBE',
        name: 'Senatsverwaltung für Wissenschaft, Gesundheit und Pflege (SenWGP) Berlin',
        destatis: '11'
    },
    {
        key: 'DEBB',
        name: 'Ministerium für Soziales, Gesundheit, Integration und Verbraucherschutz (MSGIV) Brandenburg',
        destatis: '12'
    },
    {
        key: 'DEHB',
        name: 'Die Senatorin für Gesundheit, Frauen und Verbraucherschutz Bremen',
        destatis: '04'
    },
    {
        key: 'DEHH',
        name: 'Behörde für Justiz und Verbraucherschutz (BJV) Hamburg',
        destatis: '02'
    },
    {
        key: 'DEHE',
        name: 'Hessisches Ministerium für Soziales und Integration (HMSI)',
        destatis: '06'
    },
    {
        key: 'DEMV',
        name: 'Ministerium für Soziales, Gesundheit und Sport des Landes Mecklenburg-Vorpommern (MSGS MV)',
        destatis: '13'
    },
    {
        key: 'DENI',
        name: 'Niedersächsisches Ministerium für Soziales, Arbeit, Gesundheit und Gleichstellung (MS)',
        destatis: '03'
    },
    {
        key: 'DENW',
        name: 'Ministerium für Umwelt, Naturschutz und Verkehr (MUNV) Nordrhein-Westfalen',
        destatis: '05'
    },
    {
        key: 'DERP',
        name: 'Ministerium für Klimaschutz, Umwelt, Energie, und Mobilität (MKUEM) Rheinland-Pfalz',
        destatis: '07'
    },
    {
        key: 'DESL',
        name: 'Ministerium für Arbeit, Soziales, Frauen und Gesundheit (MASFG) Saarland',
        destatis: '10'
    },
    {
        key: 'DESN',
        name: 'Sächsisches Staatsministerium für Soziales und Gesellschaftlichen Zusammenhalt (SMS)',
        destatis: '14'
    },
    {
        key: 'DEST',
        name: 'Ministerium für Arbeit, Soziales, Gesundheit und Gleichstellung Sachsen-Anhalts (MS)',
        destatis: '15'
    },
    {
        key: 'DESH',
        name: 'Ministerium für Justiz und Gesundheit (JUMI) Schleswig-Holstein',
        destatis: '01'
    },
    {
        key: 'DETH',
        name: 'Thüringer Landesamt für Verbraucherschutz (TLV)',
        destatis: '16'
    }
];
export type CustomerMap = { [key: string]: string };
export type FederalStateIdMap = { [key: string]: number };
export const customerNames: CustomerMap = customers.reduce(
    (state, current) => {
        state[current.key] = current.name;
        return state;
    },
    <CustomerMap>{}
);
export const customerNamesV2: CustomerMap = customers.reduce(
    (state, current) => {
        state[current.key.slice(2, 4)] = current.name;
        return state;
    },
    <CustomerMap>{}
);
export const federalStateIds: FederalStateIdMap = customers.reduce(
    (state, current) => {
        state[current.key.slice(2, 4)] = Number(current.destatis);
        return state;
    },
    <FederalStateIdMap>{}
);

export default customers;
